/* eslint-disable max-lines */
import * as React from 'react';

export const MaternalCapitalIcon = () => (
  <svg width="56" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".6" d="M46 46.475V14.517L22.95 0 0 14.517v31.958L22.95 62 46 46.475z" fill="#fff" />
    <path
      d="M30 48.7h5.7c8.5 0 15.4-6.9 15.4-15.4H32.9l-.1-15.9H30c-8.5 0-15.4 6.9-15.4 15.4v.5c0 8.5 6.9 15.4 15.4 15.4z"
      fill="url(#maternal_paint0_linear)"
    />
    <path
      d="M51.1 33.2H14.6c0 8.56 6.94 15.5 15.5 15.5h5.5c8.56 0 15.5-6.94 15.5-15.5z"
      fill="url(#maternal_paint1_linear)"
    />
    <path
      d="M30 48.7h5.7c8.5 0 15.4-6.9 15.4-15.4H32.9l-.1-15.9H30c-8.5 0-15.4 6.9-15.4 15.4v.5c0 8.5 6.9 15.4 15.4 15.4z"
      fill="url(#maternal_paint2_linear)"
    />
    <path d="M52.6 30.3a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z" fill="#FF7E00" />
    <path
      d="M50.2 27.6c0-1.3 1.1-2.4 2.4-2.4.7 0 1.3.3 1.7.7l.2-.2c-.5-.5-1.2-.8-1.9-.8-1.5 0-2.7 1.2-2.7 2.7 0 .8.3 1.5.8 1.9l.2-.2c-.4-.4-.7-1-.7-1.7z"
      fill="url(#maternal_paint3_linear)"
    />
    <path
      d="M23.7 50.1c-3.6 0-6.6 2.9-6.6 6.6 0 3.6 2.9 6.6 6.6 6.6 3.7 0 6.6-2.9 6.6-6.6-.1-3.7-3-6.6-6.6-6.6zm0 9.2c-1.5 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6zM43.1 50.1c-3.6 0-6.6 2.9-6.6 6.6 0 3.6 2.9 6.6 6.6 6.6 3.7 0 6.6-2.9 6.6-6.6-.1-3.7-3-6.6-6.6-6.6zm0 9.2c-1.5 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6z"
      fill="#FF7E00"
    />
    <path
      d="M17.8 56.7c0-3.2 2.6-5.8 5.8-5.8 1.6 0 3.1.7 4.2 1.8l.6-.6c-1.2-1.2-2.9-2-4.7-2-3.6 0-6.6 2.9-6.6 6.6 0 1.9.8 3.5 2 4.7l.6-.6c-1.2-1-1.9-2.5-1.9-4.1z"
      fill="url(#maternal_paint4_linear)"
    />
    <path
      d="M26.245 56.71c0 1.5-1.2 2.6-2.6 2.6-.7 0-1.4-.3-1.9-.8l-.2.3c.5.6 1.3.9 2.1.9 1.6 0 3-1.3 3-3 0-.8-.3-1.6-.9-2.2l-.2.3c.4.5.7 1.2.7 1.9z"
      fill="url(#maternal_paint5_linear)"
    />
    <path
      d="M37.2 56.7c0-3.2 2.6-5.8 5.8-5.8 1.6 0 3.1.7 4.2 1.8l.6-.6c-1.2-1.2-2.9-2-4.7-2-3.6 0-6.6 2.9-6.6 6.6 0 1.9.8 3.5 2 4.7l.6-.6c-1.2-1-1.9-2.5-1.9-4.1z"
      fill="url(#maternal_paint6_linear)"
    />
    <path
      d="M45.653 56.702c0 1.5-1.2 2.6-2.6 2.6-.7 0-1.4-.3-1.9-.8l-.2.3c.5.6 1.3.9 2.1.9 1.6 0 3-1.3 3-3 0-.8-.3-1.6-.9-2.2l-.2.3c.3.5.7 1.2.7 1.9z"
      fill="url(#maternal_paint7_linear)"
    />
    <path
      d="M29.6 56.7c0 3.2-2.6 5.8-5.8 5.8-1.6 0-3.1-.7-4.2-1.8l-.6.6c1.2 1.2 2.9 2 4.7 2 3.6 0 6.6-2.9 6.6-6.6 0-1.9-.8-3.5-2-4.7l-.6.6c1.2 1 1.9 2.5 1.9 4.1z"
      fill="url(#maternal_paint8_linear)"
    />
    <path
      d="M49 56.7c0 3.2-2.6 5.8-5.8 5.8-1.6 0-3.1-.7-4.2-1.8l-.6.6c1.2 1.2 2.9 2 4.7 2 3.6 0 6.6-2.9 6.6-6.6 0-1.9-.8-3.5-2-4.7l-.6.6c1.3 1 1.9 2.5 1.9 4.1z"
      fill="url(#maternal_paint9_linear)"
    />
    <path d="M33 36a3 3 0 100-6 3 3 0 000 6z" fill="#FF7E00" />
    <path d="M33 34.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z" fill="#fff" />
    <path
      d="M30.375 33c0-1.5 1.125-2.625 2.625-2.625.75 0 1.375.25 1.875.75l.25-.25C34.625 30.25 33.875 30 33 30c-1.625 0-3 1.375-3 3 0 .875.375 1.625.875 2.125l.25-.25c-.5-.375-.75-1.125-.75-1.875z"
      fill="url(#maternal_paint10_linear)"
    />
    <path
      d="M35.625 33c0 1.5-1.125 2.625-2.625 2.625-.75 0-1.375-.25-1.875-.75l-.25.25c.5.625 1.25.875 2.125.875 1.625 0 3-1.375 3-3 0-.875-.375-1.625-.875-2.125l-.25.25c.5.5.75 1.125.75 1.875z"
      fill="url(#maternal_paint11_linear)"
    />
    <defs>
      <linearGradient
        id="maternal_paint0_linear"
        x1="16.073"
        y1="19.659"
        x2="43.609"
        y2="47.195"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".001" stopColor="#FF8003" stopOpacity=".602" />
        <stop offset=".011" stopColor="#FF9227" stopOpacity=".623" />
        <stop offset=".021" stopColor="#FFA247" stopOpacity=".646" />
        <stop offset=".033" stopColor="#FFB062" stopOpacity=".672" />
        <stop offset=".047" stopColor="#FFBB79" stopOpacity=".702" />
        <stop offset=".063" stopColor="#FFC489" stopOpacity=".736" />
        <stop offset=".083" stopColor="#FFCA95" stopOpacity=".779" />
        <stop offset=".11" stopColor="#FFCD9C" stopOpacity=".838" />
        <stop offset=".185" stopColor="#FFCE9E" />
        <stop offset=".433" stopColor="#FFA853" />
        <stop offset=".652" stopColor="#FF8A17" />
        <stop offset=".756" stopColor="#FF7E00" />
      </linearGradient>
      <linearGradient
        id="maternal_paint1_linear"
        x1="32.889"
        y1="47.611"
        x2="32.889"
        y2="33.803"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7E00" stopOpacity="0" />
        <stop offset="1" stopColor="#FF7E00" />
      </linearGradient>
      <linearGradient
        id="maternal_paint2_linear"
        x1="16.073"
        y1="19.659"
        x2="43.609"
        y2="47.195"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".001" stopColor="#FF8003" stopOpacity=".602" />
        <stop offset=".011" stopColor="#FF9227" stopOpacity=".623" />
        <stop offset=".021" stopColor="#FFA247" stopOpacity=".646" />
        <stop offset=".033" stopColor="#FFB062" stopOpacity=".672" />
        <stop offset=".047" stopColor="#FFBB79" stopOpacity=".702" />
        <stop offset=".063" stopColor="#FFC489" stopOpacity=".736" />
        <stop offset=".083" stopColor="#FFCA95" stopOpacity=".779" />
        <stop offset=".11" stopColor="#FFCD9C" stopOpacity=".838" />
        <stop offset=".185" stopColor="#FFCE9E" />
        <stop offset=".433" stopColor="#FFA853" stopOpacity=".565" />
        <stop offset=".652" stopColor="#FF8A17" stopOpacity=".182" />
        <stop offset=".756" stopColor="#FF7E00" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="maternal_paint3_linear"
        x1="49.719"
        y1="28.543"
        x2="53.457"
        y2="24.805"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint4_linear"
        x1="16.692"
        y1="58.987"
        x2="25.775"
        y2="49.905"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint5_linear"
        x1="26.75"
        y1="55.682"
        x2="22.641"
        y2="59.791"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint6_linear"
        x1="36.055"
        y1="58.987"
        x2="45.138"
        y2="49.905"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint7_linear"
        x1="46.12"
        y1="55.674"
        x2="42.012"
        y2="59.783"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint8_linear"
        x1="30.672"
        y1="54.388"
        x2="21.59"
        y2="63.471"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".342" stopColor="#F66800" stopOpacity=".83" />
        <stop offset=".527" stopColor="#F25D00" />
        <stop offset=".672" stopColor="#F56500" stopOpacity=".855" />
        <stop offset=".896" stopColor="#FE7A00" stopOpacity=".632" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint9_linear"
        x1="50.154"
        y1="54.388"
        x2="41.072"
        y2="63.471"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".342" stopColor="#F66800" stopOpacity=".83" />
        <stop offset=".527" stopColor="#F25D00" />
        <stop offset=".672" stopColor="#F56500" stopOpacity=".855" />
        <stop offset=".896" stopColor="#FE7A00" stopOpacity=".632" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint10_linear"
        x1="29.838"
        y1="34.086"
        x2="33.973"
        y2="29.952"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".282" stopColor="#FFAF62" stopOpacity=".683" />
        <stop offset=".527" stopColor="#FFEAD6" stopOpacity=".6" />
        <stop offset=".549" stopColor="#FFE2C6" stopOpacity=".641" />
        <stop offset=".592" stopColor="#FFD6AE" stopOpacity=".72" />
        <stop offset=".636" stopColor="#FFCD9D" stopOpacity=".804" />
        <stop offset=".684" stopColor="#FFC892" stopOpacity=".894" />
        <stop offset=".741" stopColor="#FFC68F" />
        <stop offset=".795" stopColor="#FFB369" stopOpacity=".884" />
        <stop offset=".915" stopColor="#FF830A" stopOpacity=".627" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
      <linearGradient
        id="maternal_paint11_linear"
        x1="36.134"
        y1="31.962"
        x2="32"
        y2="36.096"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".093" stopColor="#FF7E00" stopOpacity=".6" />
        <stop offset=".2" stopColor="#F97200" stopOpacity=".695" />
        <stop offset=".398" stopColor="#F06100" stopOpacity=".869" />
        <stop offset=".547" stopColor="#ED5B00" />
        <stop offset=".736" stopColor="#F56A00" stopOpacity=".801" />
        <stop offset=".928" stopColor="#FF7E00" stopOpacity=".6" />
      </linearGradient>
    </defs>
  </svg>
);

MaternalCapitalIcon.displayName = 'MaternalCapitalIcon';
